<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">
            <div class="pb-24 font-size-18 font-weight-300">
                <button (click)="today()" mat-raised-button class="mr-8" color="accent">{{ 'Today'|translate }}</button>
                <button (click)="yesterday()" mat-raised-button class="mr-8"
                        color="accent">{{ 'Yesterday'|translate }}
                </button>
                <button (click)="lastWeek()" mat-raised-button class="mr-8" color="accent">{{ 'Last week'|translate }}
                </button>
                <button (click)="lastMonth()" mat-raised-button class="mr-8"
                        color="accent">{{ 'Last month'|translate }}
                </button>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" style="padding-bottom: 10px;">
                <div class="widget pt-0" fxFlex="100">

                    <div class="fuse-card content-card auto-width">
                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{ 'Date range'|translate }}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <div class="row">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Start date</mat-label>
                                                <input matInput formControlName="start" [matDatepicker]="picker"
                                                       (dateChange)="reloadStats($event)">
                                                <mat-datepicker-toggle matSuffix
                                                                       [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline">
                                                <mat-label>End date</mat-label>
                                                <input matInput formControlName="end" [matDatepicker]="picker2"
                                                       (dateChange)="reloadStats($event)">
                                                <mat-datepicker-toggle matSuffix
                                                                       [for]="picker2"></mat-datepicker-toggle>
                                                <mat-datepicker #picker2></mat-datepicker>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" style="width: 200px;">
                                                <mat-label>{{ 'Worker'|translate }}</mat-label>
                                                <mat-select formControlName="worker" (selectionChange)="setWorker()">
                                                    <mat-option [value]="worker.id" *ngFor="let worker of workers">
                                                        {{ worker.firstName }} {{ worker.lastName }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" style="padding-bottom: 10px;">
                <div class="widget pt-0" fxFlex="100">
                    <div class="fuse-card content-card auto-width">
                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h1 pr-16">
                                {{ 'Raport wykonanych usług'|translate }}
                                <!--                                <app-info message="Multi sport report. Used type 'added' means that voucher has been added to card. Used type 'used' means that voucher exercise was done."></app-info>-->
                            </div>
                        </div>
                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{ 'Date'|translate }}</th>
                                <th>{{ 'Voucher'|translate }}</th>
                                <th>{{ 'Service'|translate }}</th>
                                <th>{{ 'Customer'|translate }}</th>
                                <th>{{ 'Worker'|translate }}</th>
                                <th class="text-right">{{ 'Quantity'|translate }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of reportData">
                                <td>{{ row.createdAt|date: 'dd.MM.y HH:mm': 'UTC+' + row.timezoneOffset: locale }}</td>
                                <td><span *ngIf="row.voucher">{{ row.voucher.name }}</span></td>
                                <td><span *ngIf="row.service">{{ row.service.name }}</span></td>
                                <td>{{ row.customer.firstName }} {{ row.customer.lastName }}</td>
                                <td><span *ngIf="row.worker">{{ row.worker.firstName }} {{ row.worker.lastName }}
                                    ({{ row.worker.username }})</span></td>
                                <td class="text-right">{{ row.quantity }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right" style="font-weight: bold;">{{ 'Total'|translate }}</td>
                                <td class="text-right" style="font-weight: bold;">{{ summary }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
